import { Fragment, useEffect } from "react";
import { Modal, Form, Input, message } from "antd";
import { useCreateUserAgentRole } from "../../use-cases/create-agent-role";

export const AddRoleAgentModel = ({
    model,
    setModel,
    editdata,
    setEditData,
    refetch
}: any) => {
    const [form] = Form.useForm();
    const { mutate, isLoading } = useCreateUserAgentRole();

    // ---------- SUBMIT HANDLER ----------
    const handleSubmit = () => {
        form.validateFields().then((values) => {
            let payload: any = {};

            if (editdata) {
                // UPDATE ROLE
                payload = {
                    flag: "update",
                    roleId: editdata?.id,
                    roleName: values.Name
                };
            } else {
                // INSERT ROLE
                payload = {
                    flag: "insert",
                    roleName: values.Name
                };
            }

            mutate(payload, {
                onSuccess: (data: any) => {
                    form.resetFields();
                    setEditData(null);
                    setModel(false);
                    if(data?.ResponseStatus==0){
                        message.error(data?.ResponseMessage)
                    }else{
                        message.success(data?.ResponseMessage)
                    }
                    refetch()
                }
            });
        });
    };
    // ---------- PREFILL WHEN EDIT ----------
    useEffect(() => {
        if (editdata) {
            form.setFieldsValue({
                Name: editdata?.role_name
            });
        } else {
            form.resetFields();
        }
    }, [editdata]);

    return (
        <Fragment>
            {/* ADD / EDIT MODAL */}
            <Modal
                title={editdata ? "Edit Role" : "Add Role"}
                open={model}
                onCancel={() => {
                    setModel(false);
                    setEditData(null);
                }}
                onOk={handleSubmit}
                okText={editdata ? "Update" : "Save"}
                confirmLoading={isLoading}
            >
                <Form layout="vertical" form={form}>
                    <Form.Item
                        label="Role Name"
                        name="Name"
                        rules={[
                            { required: true, message: "Please enter role name" },

                            // 🚀 Custom validator to prevent spaces-only input
                         
                        ]}
                    >
                        <Input placeholder="Enter role name" />
                    </Form.Item>
                </Form>
            </Modal>
        </Fragment>
    );
};
